module.exports = __webpack_public_path__ + "assets/img/map-gsjs.7db39da3.svg";